export default __webpack_public_path__ + "static/media/office_1.cd9a8a70.jpeg";